import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFoodpandaComponent } from './simple-icons-foodpanda.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFoodpandaComponent ],
    exports:      [ SimpleIconsFoodpandaComponent ],
    bootstrap:    []
})
export class SimpleIconsFoodpandaModule {}
